import React from "react";
import Loader from 'react-loader-spinner'
import HttpService from '../../utils/Http.services';
import { checkTextTranslation, getObject, translate } from "../../utils/useful";
import SubformInput from "./SubformInput";


class VariantsInventory extends React.Component {

    state = {
        isOpen: false,
        data: [],
        fields: [
            { key: 'name', type: 'TextInput', col: '2', information: { label: '{{lang}}Variant', placeholder: '{{lang}}Variant', required: false, disabled: true }, showMain: true },
            { key: 'price', type: 'PriceInput', col: '2', information: { label: '{{lang}}Price', placeholder: '0', withDiscount: true, required: false, disabled: false }, showMain: true },
            // { key: 'stockValue', type: 'PriceInput', col: '2', information: { label: '{{lang}}Cost of goods', placeholder: '0', required: false, disabled: true }, showMain: true },
            { key: 'SKU', type: 'TextInput', col: '2', information: { label: '{{lang}}SKU', placeholder: '0', required: false, disabled: false }, showMain: true },
            { key: 'stock', type: 'StockInput', col: '4', information: { label: '{{lang}}Stock', placeholder: '0', required: false, disabled: false }, showMain: true },
            { key: 'dimensions', type: 'DimensionsInput', col: '2', information: { label: '{{lang}}Dimensions', placeholder: '0', required: false, disabled: false }, showMain: true },

        ]
    }

    componentDidMount() {


        this.setState({ initData: this.props.data, data: this.props.data ?? [], basePrice: this.props.fullData?.price ? JSON.parse(JSON.stringify(this.props.fullData?.price)) : this.props.fullData?.price }, () => {
            this.init()
        })
    }

    componentDidUpdate(prevProps) {

        let variantsKey = this.props.header?.information?.variantsKey

        let variants = getObject(this.props.fullData, variantsKey)
        // let prevVariants = getObject(prevProps.fullData, variantsKey)

        if (variants && (JSON.stringify(variants) != JSON.stringify(this.state.variants))) {
            this.init()
        }

        if (this.props.fullData?.price != this.state.basePrice) {
            this.setState({ basePrice: this.props.fullData?.price, oldPrice: this.state.basePrice }, () => {
                this.init()
            })
        }
    }

    init() {

        let fullData = this.props.fullData
        let variantsKey = this.props.header?.information?.variantsKey
        let variants = getObject(fullData, variantsKey)
        let final = []

        variants = Array.isArray(variants) ? JSON.parse(JSON.stringify(variants)) : null

        this.setState({ variants })


        if (Array.isArray(variants)) {


            this.loopVariants(variants, 0, [], final)

            // console.log(final)


            this.setState({ data: final }, () => {
                this.props.changeValue(null, final)
            })

        }

    }


    loopVariants = (variants, index, options, final) => {

        // console.log(options)
        let variant = variants[index]
        if (variant) {
            // else {
            // console.log(variant)
            if (Array.isArray(variant.options) && variant.options.length > 0) {

                variant.options.forEach(option => {
                    if (option.trim() != '' && variant.name && variant.name != '') {
                        this.loopVariants(variants, (index + 1), [...options, { key: variant.name.toLowerCase(), value: option }], final)
                    }
                });
            } else {
                this.loopVariants(variants, (index + 1), [...options], final)
            }

        } else {


            let myOption = ''
            let attributes = {}
            options.forEach((element, index) => {

                // console.log(element)
                if (element.value != '') {
                    myOption = myOption + element.value + ((index < options.length - 1) ? ' | ' : '')
                    attributes[element.key] = element.value
                }

            });

            if (myOption != '') {
                let newOption = { name: myOption, attributes: attributes, price: this.state.basePrice ? JSON.parse(JSON.stringify(this.state.basePrice)) : this.state.basePrice }
                let availableOption

                this.state.data.forEach(available => {
                    if (JSON.stringify(available.attributes) == JSON.stringify(newOption.attributes)) {
                        availableOption = available
                    }
                })

                if (availableOption) {
                    newOption = availableOption

                    if (JSON.stringify(newOption.price) == JSON.stringify(this.state.oldPrice)) {
                        newOption.price = this.state.basePrice ? JSON.parse(JSON.stringify(this.state.basePrice)) : this.state.basePrice
                    }


                }


                // if(available.price != )

                final.push(newOption)
            }

        }
    }


    changeValue = (key, value, extra) => {

        // console.log(this.props.header?.key)
        // console.log(value)
        

        this.props.changeValue(this.props.header?.key, value, this.props.extra)
    }



    render() {
        return (
            <div className='mt-0' style={{ width: '100%', position: 'relative' }} >

                <SubformInput data={this.state.data} header={{ information: { headers: this.state.fields, addDisabled: true, removeDisabled: true, } }} changeValue={this.changeValue} variables={this.props.variables} inputClass="bordered-input" />

            </div>
        );
    }
}


export default VariantsInventory;
